const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');
const CloverPaymentAndRefundVoidReason = require('@/lib/PaymentMethods/Clover/Enums/CloverPaymentAndRefundVoidReason');

class CloverTransactionVoidRequestRecord extends AbstractCloverRequestRecord {
    /**
     * Cancels the specified payment before it is settled. The payment will be recorded as a void, but Clover may
     * convert the void into a refund at the payment gateway under certain conditions. For final payments (where the
     * final flag is set to true), a void cannot be processed outside of the settlement window (more than 25 minutes
     * after the payment). When a void is not possible, Clover performs a refund instead of a void.
     *
     * @param {string} paymentId
     * @param {string} voidReason
     */
    constructor(paymentId, voidReason) {
        if (!paymentId || paymentId.trim() === '') {
            throw new Error('paymentId is required');
        }
        if (
            !voidReason || !CloverPaymentAndRefundVoidReason.hasOwnProperty(voidReason)
        ) {
            const methods = Object.values(CloverPaymentAndRefundVoidReason).join(', ');
            throw new Error('voidReason is required and must be one of ' + methods);
        }
        // @link https://docs.clover.com/reference/void
        const url = '/connect/v1/payments/' + paymentId + '/void';
        super(
            'POST',
            url
        );
        this.data = {
            voidReason,
        };
    }
}

module.exports = CloverTransactionVoidRequestRecord;
